export default {"src":"/_next/static/media/tiktok.a5e01eed.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};